import React, { useState } from 'react';

const FaQ = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const faqItems = [
        {
            id: 1,
            question: 'How Do you do your research on business firm?',
            answer: 'Our solutions are scalable and can grow with your business, ensuring that you get the most value out of your investment.',
        },
        {
            id: 2,
            question: 'How many consultants do you have?',
            answer: 'Our solutions are scalable and can grow with your business, ensuring that you get the most value out of your investment.',
        },
        {
            id: 3,
            question: 'What method do you follow to do investment analysis?',
            answer: 'Our solutions are scalable and can grow with your business, ensuring that you get the most value out of your investment.',
        },
        {
            id: 4,
            question: 'What are the contact addresses of yours?',
            answer: 'Our solutions are scalable and can grow with your business, ensuring that you get the most value out of your investment.',
        },
        {
            id: 5,
            question: 'What method do you follow to do market analysis?',
            answer: 'Our solutions are scalable and can grow with your business, ensuring that you get the most value out of your investment.',
        },
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index); // Toggle active index
    };

    return (
        <div className="faq-section-four">
            <div className="container">
                <div className="row gutter-y-30">
                    <div className="col-lg-5">
                        <div className="faq-left-four">
                            <div className="heading-box">
                                <span className="sub-title animate fadeInUp wow" data-wow-duration="1500ms">
                                    FAQ
                                </span>
                                <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                    Ask Us What you want to know from us
                                </h2>
                            </div>
                            <p className="lead">
                                At uniquo, we are a renowned global consulting firm committed to collaborating with business and societal leaders in challenges and opportunities.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="faq-box-four">
                            <div className="accordion" id="accordionfaq">
                                {faqItems.map((item, index) => (
                                    <div
                                        key={item.id}
                                        className={`accordion-item animate fadeInRight wow`}
                                        data-wow-duration="1500ms"
                                        data-wow-delay={`${(index + 1) * 200}ms`}
                                    >
                                        <h4 className="accordion-header" id={`heading${item.id}`}>
                                            <button
                                                className={`accordion-button ${activeIndex === index ? '' : 'collapsed'}`}
                                                type="button"
                                                onClick={() => toggleAccordion(index)} // Toggle on click
                                            >
                                                {item.question}
                                            </button>
                                        </h4>
                                        <div
                                            className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
                                            aria-labelledby={`heading${item.id}`}
                                        >
                                            <div className="accordion-body">
                                                <p>{item.answer}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FaQ;